import { render, staticRenderFns } from "./ModalAddAlternateLogin.vue?vue&type=template&id=e528d066&"
import script from "./ModalAddAlternateLogin.vue?vue&type=script&lang=js&"
export * from "./ModalAddAlternateLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports